import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent border-radius-50 rounded-full animate-spin"></div>
        <p className="mt-4 text-lg font-medium text-primary">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
